export default __webpack_public_path__ + "static/media/twitterLight.ca809c27.svg";